import React from 'react';
import {IoCloseOutline, IoArrowForwardSharp} from 'react-icons/io5';
import Recaptcha from 'react-google-recaptcha';
import {Link, navigate} from 'gatsby';

const RECAPTCHA_KEY = '6Lfq6TcbAAAAAF7_iMvbS0Czl_0PpHUlBvozxT3_';

export default function Contact(props) {
  // console.log(props);
  const recaptchaRef = React.createRef(); // new Ref for reCaptcha
  const [showSucess, setShowSuccess] = React.useState(false);
  const [showFailure, setShowFailure] = React.useState(false);
  const [buttonDisabled, setButtonDisabled] = React.useState(true);
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    ['bot-field']: '',
  });

  const encode = (data) => {
    return Object.keys(data)
        .map(
            (key) =>
              encodeURIComponent(key) +
                    '=' +
                    encodeURIComponent(data[key]),
        )
        .join('&');
  };

  const showSuccessPopup = () => {
    setShowSuccess(true);
    setTimeout((_) => {
      setShowSuccess(false);
    }, 3000);
  };

  const showFailurePopup = () => {
    showFailure(true);
    setTimeout((_) => {
      setShowFailure(false);
    }, 3000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const recaptchaValue = recaptchaRef.current.getValue();
    fetch('/', {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: encode({
        'form-name': form.getAttribute('name'),
        'g-recaptcha-response': recaptchaValue,
        ...formData,
      }),
    })
        .then(() => {
          setFormData({
            name: '',
            email: '',
            subject: '',
            message: '',
            ['bot-field']: '',
          });
          showSuccessPopup();
        })
        .catch((error) => {
          showFailurePopup();
          console.log(error);
        });
  };

  return !props.data ? null : (
        <div className=" w-full h-full pb-16 bg-primary text-white lg:pb-40">
          <div className="flex items-center justify-between py-2 px-4 w-full md:px-8">
            <div className="py-3">
              <div>
                <h4 className=" cursor-pointer font-semibold tracking-tighter text-2xl md:font-bold">
                  <Link to="/">{props.data.title}</Link>
                </h4>
              </div>
            </div>
            <div className="flex flex-grow-0 items-center py-3">
              <div className=" flex-row flex justify-end text-3xl cursor-pointer transition-all text-opacity-75 text-white hover:text-opacity-100">
                <div
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <IoCloseOutline />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 w-11/12 grid grid-cols-1 gap-12 mx-auto md:w-4/5 md:mt-24 lg:w-11/12 lg:grid-cols-2 lg:ml-8 xl:ml-32">
            <div>
              <div className="">
                <div className=" w-10/12 ">
                  <h2 className="text-5xl mb-8 font-bold tracking-tighter">
                                Contact now
                  </h2>
                  <p className="text-xl leading-9 mb-8 font-normal tracking-tight">
                    {props.data.subtitle}
                  </p>
                </div>
              </div>
              <div className=" font-normal text-opacity-50 text-white ">
                <form
                  name="contacts v1"
                  method="post"
                  action="/thanks/"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  data-netlify-recaptcha="true"
                  onSubmit={handleSubmit}
                >
                  <input
                    type="hidden"
                    name="form-name"
                    value="contacts v1"
                  />
                  <div hidden>
                    <input
                      placeholder="don't filled this out"
                      type="text"
                      name="bot-field"
                      onChange={handleChange}
                    />
                  </div>
                  <div className=" mt-7">
                    <input
                      placeholder="Your Name"
                      required
                      name="name"
                      type="text"
                      onChange={handleChange}
                      value={formData.name}
                      className=" w-full lg:w-9/12 transition-all duration-300 border-0 border-b border-opacity-50 border-white border-solid text-opacity-50 text-white py-2 pr-3 h-12 bg-transparent focus:outline-none focus:border-blue-700"
                    />
                  </div>
                  <div className=" mt-7">
                    <input
                      placeholder="Your Email"
                      required
                      name="email"
                      type="email"
                      onChange={handleChange}
                      value={formData.email}
                      className=" w-full lg:w-9/12 transition-all duration-300 border-0 border-b border-opacity-50 border-white border-solid text-opacity-50 text-white py-2 pr-3 h-12 bg-transparent focus:outline-none focus:border-blue-700"
                    />
                  </div>
                  <div className=" mt-7">
                    <input
                      placeholder="Subject"
                      required
                      name="subject"
                      type="text"
                      onChange={handleChange}
                      value={formData.subject}
                      className=" w-full lg:w-9/12 transition-all duration-300 border-0 border-b border-opacity-50 border-white border-solid text-opacity-50 text-white py-2 pr-3 h-12 bg-transparent focus:outline-none focus:border-blue-700"
                    />
                  </div>
                  <div className=" mt-7 mb-7">
                    <textarea
                      placeholder="Write your message"
                      rows="5"
                      required
                      name="message"
                      onChange={handleChange}
                      value={formData.message}
                      className=" w-full lg:w-9/12 transition-all duration-300 border-0 border-b border-opacity-50 border-white border-solid text-opacity-50 text-white py-2 pr-3 bg-transparent focus:outline-none focus:border-blue-700"
                    />
                  </div>
                  <Recaptcha
                    ref={recaptchaRef}
                    sitekey={RECAPTCHA_KEY}
                    size="normal"
                    id="recaptcha-google"
                    onChange={() => setButtonDisabled(false)} // disable the disabled button!
                  />
                  <button
                    type="submit"
                    name="submitButton"
                    disabled={buttonDisabled}
                    className=" mt-12 px-8 py-6 rounded-full bg-blue-700 uppercase shadow-secondary text-white  relative focus:outline-none flex items-center transition-all duration-500 transform hover:-translate-y-3 hover:bg-blue-600"
                  >
                    <span className=" font-bold text-sm tracking-wider mr-2">
                                    Send
                    </span>
                    <span className=" ">
                      <IoArrowForwardSharp />
                    </span>
                  </button>
                </form>
              </div>
            </div>
            <div>
              <div className=" mt-4 w-full bg-opacity-10 bg-blue-500 rounded-xl box-border p-8 lg:mt-52 lg:w-96 lg:p-12">
                <div className="">
                  <p className=" text-xl tracking-tight mb-2">
                                Email me at
                  </p>
                  <a
                    href={`mailto:${props.data.email}`}
                    className=" font-bold text-blue-500"
                  >
                    {' '}
                    <span>{props.data.email}</span>{' '}
                  </a>
                </div>
                {
                  props.data.phone == ""? null : 
                  <div className=" mt-12">
                    <p className=" text-xl tracking-tight mb-2">
                                  Call me at
                    </p>
                    <a
                      href={`tel:${props.data.phone}`}
                      className=" font-bold text-blue-500"
                    >
                      {' '}
                      <span>{props.data.phone}</span>{' '}
                    </a>
                  </div>
                  }
                <div className=" mt-12">
                  <p className=" text-xl tracking-tight mb-2">
                                Location
                  </p>
                  <a
                    href={props.data.locationLink}
                    className=" font-bold text-blue-500"
                  >
                    {' '}
                    <span>{props.data.location}</span>{' '}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className=" fixed bottom-4 left-4">
            <div className="flex flex-col jusctify-center">
              {showSucess ? (
                        <div className="flex items-center bg-green-500 border-l-4 border-green-700 py-2 px-3 mb-2 shadow-primary">
                          <div className="text-green-500 rounded-full bg-white mr-3">
                            <svg
                              width="1.8em"
                              height="1.8em"
                              viewBox="0 0 16 16"
                              className="bi bi-check"
                              fill="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
                              />
                            </svg>
                          </div>
                          {/* <!-- message --> */}
                          <div className="text-white max-w-xs ">
                                Thank you
                          </div>
                        </div>
                    ) : null}

              {showFailure ? (
                        <div className="flex items-center bg-red-500 border-l-4 border-red-700 py-2 px-3 shadow-primary mb-2">
                          <div className="text-red-500 rounded-full bg-white mr-3">
                            <svg
                              width="1.8em"
                              height="1.8em"
                              viewBox="0 0 16 16"
                              className="bi bi-x"
                              fill="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
                              />
                              <path
                                fillRule="evenodd"
                                d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
                              />
                            </svg>
                          </div>
                          <div className="text-white max-w-xs ">
                                Sorry, there might be some issue. You can mail
                                me directly.
                          </div>
                        </div>
                    ) : null}
            </div>
          </div>
        </div>
    );
}
